import {useMemo} from "react";
import formatDecimal from "#lib/formatDecimal";

export const useInvisible = (value, precision = 4, after = null) => {
  return useMemo(() => {
    let invisible = Math.ceil(value).toString() + '.' + '9'.repeat(precision);
    return formatDecimal(invisible, precision) + (after ? " " + after : '');
  }, [after, precision, value]);

}